// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b61da0ec","453":"b685b191","455":"43824911"}[chunkId] + ".chunk.js";
};